import { render, staticRenderFns } from "./QueueActiveCall.vue?vue&type=template&id=53e90a4e"
import script from "./QueueActiveCall.vue?vue&type=script&lang=js"
export * from "./QueueActiveCall.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports